import { createSlice } from '@reduxjs/toolkit';

export const cartPrice = createSlice({
  name: 'cartPrice',
  initialState: {
    data: {},
  },

  reducers: {
    setCartPrice: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setCartPrice } = cartPrice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getCartPrice = (state) => state.cartPrice.data;

export default cartPrice.reducer;
